import React from "react";

import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

import RuiMenu from "@rui/Menu";
import RuiMenuItem, { MenuItemProps as RuiMenuItemProps } from "@rui/MenuItem";
import { Row } from "@rui/Stack";

export const MenuButton = styled(Button)(({ theme }) => ({
  height: "48px",
  border: "1px solid",
  borderRadius: "8px",
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  borderColor: theme.palette.shades.neutral[100],
  color: theme.palette.shades.neutral[500],
  justifyContent: "space-between",
}));

export const MenuItemContainer = styled(Row)(({ theme }) => ({
  alignItems: "center",
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: "8px",
  padding: "6px 10px",
  maxHeight: "48px",
}));

export const Menu = styled(RuiMenu)(({ theme }) => ({
  "& .MuiPaper-root": {
    boxShadow: theme.shadows[4],
    paddingRight: theme.spacing(1),
    maxHeight: "350px",
    minWidth: "200px",
  },
}));

type MenuItemProps = RuiMenuItemProps & { isCategory?: boolean };

export const MenuItem = styled<React.FC<MenuItemProps>>(
  ({ isCategory: _is, ...props }) => <RuiMenuItem {...props} />
)(({ theme, isCategory = false }) => ({
  height: isCategory ? "32px" : "28px",
  "&:not(:first-of-type)": {
    marginTop: theme.spacing(0.5),
  },
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(0.5),
  ...(isCategory && {
    paddingLeft: theme.spacing(0.5),
  }),
  "& .checkbox__icon": {
    height: "15px",
    width: "15px",
    borderWidth: "1.67px",
    backgroundColor: "#FFF",
    "&.checkbox__icon--checked svg": {
      fontSize: "20px",
    },
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFF",
  },
}));
